import '../../../static/scripts/livesearch/jquery.live-search';
import '../animations/_selectric';
import Lazyload from 'lazyload';
import Accordion from '../components/_accordion';

$(document).ready(function(){

    const container = $("[js-filter-list]");

    const action = container.data('filter-list-action');

    const select = $('.select-form');
    select.selectric({
            multiple: {
                separator: ', ',       // Type: String.             Description: Items separator.
                keepMenuOpen: true,    // Type: Boolean.            Description: Close after an item is selected.
                maxLabelEntries: false // Type: Boolean or Integer. Description: Max selected items do show.
            }
        }
    );

    container.liveSearch({
        path: ajaxurl,
        action: action,
        perPage: 10,
        resultsContainer: "[js-filter-destination]",
        paginationContainer: ".pagination",
        filters: ".select-form",
        render: function (item) {
            if('string' === typeof item){
                return item;

            }
        }
    });

    container.on("livesearch.rendered", function (event, datas) {
        Lazyload.init();
        Accordion.init();
        if (datas.items && datas.items.length) {
            $("[js-filter-empty-results]").hide();
            $('.accordion').each(function( index ) {
                let _this = $(this);
                setTimeout(function(){
                    _this.addClass('aos-animate');
                },100);
            });
        } else {
            setTimeout(function () {
                $("[js-filter-empty-results]").show();
            }, 500);

            $('[js-filter-placeholder]').fadeOut();
        }
    });

    container.on("livesearch.beforeSearch", function () {
        $('.accordion').fadeOut(200);
    });

});